export const PAGE_TYPES = {
  UNKNOWN: 'UNKNOWN',
  PROFILE: 'PROFILE',
  BULK: 'BULK',
  SALESFORCE_ACCOUNT: 'SALESFORCE_ACCOUNT',
  HUBSPOT_COMPANY: 'HUBSPOT_COMPANY',
  LINKEDIN_COMPANY: 'LINKEDIN_COMPANY',
};

export const APP_CONTEXT = {
  PROSPECT: 'PROSPECT',
  SEARCH: 'SEARCH',
};
